import { css } from '@/styled-system/css';
import HdpSummaryAddress from 'app/shared/modules/hdp/HdpSummary/HdpSummaryAddress';
import HdpSummaryLinks from './HdpSummaryLinks';
import HdpSummaryDetails from 'app/shared/modules/hdp/HdpSummary/HdpSummaryDetails';
import HdpSummaryListingTags from 'app/shared/modules/hdp/HdpSummary/HdpSummaryListingTags';
import type { ListingDetails } from 'app/types/listingDetails.type';
import HdpSummaryCostsAndFees from 'app/shared/modules/hdp/HdpSummary/HdpSummaryCostsAndFees';
import TotalMonthlyPriceNotice from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceNotice';

const totalMonthlyPriceNoticeStyles = css({
  paddingLeft: '16px',
  paddingRight: '16px',
  marginBottom: '4px',
});

const HdpSummary = ({ listing }: { listing: ListingDetails }) => {
  const { active: isListingActive, isAllowedToRetain } = listing;
  /**
   * Data should be hidden per MLS if the listing is:
   * -- active: false
   * -- isAllowedToRetain: false
   */
  const shouldBeHiddenIfDataCannotBeRetained = isListingActive === false && isAllowedToRetain === false;

  return (
    <>
      <HdpSummaryAddress listing={listing} />
      <HdpSummaryLinks listing={listing} />
      {shouldBeHiddenIfDataCannotBeRetained ? null : <HdpSummaryDetails listing={listing} />}
      <TotalMonthlyPriceNotice listing={listing} className={totalMonthlyPriceNoticeStyles} />
      <HdpSummaryCostsAndFees />
      <HdpSummaryListingTags listing={listing} />
    </>
  );
};

export default HdpSummary;
